import { CSSProperties } from 'react';
import styled from 'styled-components';

function UnstyledSingleHexagonImage(props: {
    width?: number | string | undefined;
    height?: number | string | undefined;
    imageUrl: string;
    borderWidth?: number | undefined;
    className?: string | undefined;
    style?: CSSProperties | undefined;
}) {
    return <svg viewBox="-5 -10 210 240" className={props.className} width={props.width ?? '100%'} height={props.height ?? '100%'} style={props.style}>
        <mask id="single-hexagon-image-mask" fill="white">
            <path d="M92.79,4.551C94.209,3.737 96.531,3.737 97.951,4.551L183.808,53.807C184.513,54.212 185.108,54.949 185.568,55.739C186.024,56.525 186.369,57.399 186.369,58.204L186.369,156.709C186.369,157.513 186.024,158.388 185.568,159.173C185.108,159.964 184.513,160.701 183.808,161.105L97.95,210.358C96.531,211.173 94.209,211.172 92.79,210.359L71.647,198.23L62.506,192.987L6.93,161.106C6.225,160.701 5.629,159.964 5.17,159.173C4.714,158.388 4.369,157.513 4.369,156.709L4.369,58.204C4.369,57.399 4.714,56.525 5.17,55.739C5.629,54.949 6.225,54.212 6.93,53.807L92.79,4.551Z"/>
        </mask>
        <filter id="single-hexagon-image-shadow" colorInterpolationFilters="sRGB">
            <feDropShadow dx="2" dy="2" stdDeviation="2" floodOpacity="0.15"/>
        </filter>

        <g filter="url(#single-hexagon-image-shadow)">
            <g transform="matrix(1,0,0,1,4.63115,2.54522)" mask="url(#single-hexagon-image-mask)">
                <image x="0" y="0" width="190" height="215" xlinkHref={props.imageUrl}></image>
            </g>

            <g transform="matrix(1,0,0,1,4.63115,2.54522) translate(4 4) scale(0.96 0.963)" fill='none' stroke='#fff' strokeWidth={props.borderWidth ?? 8}>
                <path d="M185.798,50.338C188.312,51.78 190.369,55.319 190.369,58.204L190.369,156.709C190.369,159.593 188.312,163.133 185.798,164.575L99.941,213.828C97.428,215.27 93.314,215.27 90.8,213.828L69.657,201.7C67.143,200.259 63.029,197.899 60.515,196.457L4.939,164.575C2.426,163.133 0.369,159.593 0.369,156.709L0.369,58.204C0.369,55.319 2.426,51.78 4.939,50.338L90.8,1.082C93.314,-0.361 97.428,-0.361 99.941,1.082L185.798,50.338Z"/>
            </g>
        </g>
    </svg>;
}

export const SingleHexagonImage = styled(UnstyledSingleHexagonImage)`
    width: auto;
`;
